import React from "react";


const Services = () =>{
    return (
        <>
        <div className="services-section">
            <div className="card">
                <div className="card-logo">
                    <i className="fa-solid fa-message"></i>
                    <h3>Consulting</h3>
                </div>
                <div className="card-details">
                Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches to corporate strategy foster  
                collaborative thinking to further the overall value proposition.
                </div>
            </div>

            <div className="card">
                <div className="card-logo">
                <i className="fa-solid fa-code"></i>
                
                    <h3>Developing</h3>
                </div>
                <div className="card-details">
                Software developers design, program, build, deploy and maintain software using many different skills and tools. They also help      
                build software systems that power networks and devices and ensure that those systems remain functional.
                 </div>
            </div>

            <div className="card">
                <div className="card-logo">
                <i className="fa-solid fa-wand-magic-sparkles"></i>
                    <h3>Designing</h3>
                </div>
                <div className="card-details">
                A creative designer produces artwork and design concepts that can take on many different forms. For example, you might create visuals, brainstorm concepts, work with team members to develop concepts, and ensure that the final product is aligned with the company or client standards.
                    </div>
            </div>

            <div className="card">
                <div className="card-logo">
                <i className="fa-solid fa-chart-line"></i>
                    <h3>Analysis</h3>
                </div>
                <div className="card-details">
                An analysis is a detailed examination of a topic. It involves performing research and separating results into smaller, logical topics to form reasonable conclusions. It presents a specific argument about the topic and supports that argument with evidence.
                </div>
            </div>
        </div>
        </>
    )
}

export default Services;